import { FC, useState, useRef } from "react";
import { getPageTitle } from "../util";

type Props = {
  leftSectionRef: any
  content: string;
  metaDescription: string;
};

export const AiToolsTab: FC<Props> = ({ leftSectionRef, content, metaDescription }) => {

  return (
    <>

      <div style={{
        marginTop: "0px",
        padding: "20px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        backgroundColor: "#f8f9fa"
      }}>
        <h4 style={{ marginBottom: "15px", color: "#333" }}>Google Preview</h4>
        <div style={{ color: "#1a0dab", fontSize: "14px", marginBottom: "4px" }}>
          example.com › sample-page-url
        </div>
        <div style={{
          color: "#1a0dab",
          fontSize: "20px",
          marginBottom: "4px",
          textDecoration: "underline"
        }}>
          {getPageTitle(content)}
        </div>
        <div style={{
          color: "#4d5156",
          fontSize: "14px",
          lineHeight: "1.5"
        }}>
          {metaDescription || "Use the input fields to write a custom page Title and Meta description. This preview box shows you how your page will look in the search results from Google."}
        </div>
      </div>
    </>
  );
};
